// removed by extract-text-webpack-plugin
module.exports = {"progressBar":"_1ZU-M-zdDNhK673M6AE4tx","progress":"_1fymmFvwilro1c_76E4eHu","orange":"_1ud6vpGwfK7zDPGRGSei6d"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/ProgressBar/style.css
// module id = 395
// module chunks = 37